import { render, staticRenderFns } from "./IconChecklist.vue?vue&type=template&id=2197bf74"
import script from "./IconChecklist.vue?vue&type=script&lang=js"
export * from "./IconChecklist.vue?vue&type=script&lang=js"
import style0 from "./IconChecklist.vue?vue&type=style&index=0&id=2197bf74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports